import React from 'react';
import Snappy from '@/media/domains/snappy-success.svg';
import * as Styles from './ChangeDomainSuccess.styles';
import PropTypes from 'prop-types';
import { Button, IconArrow, IconCircleCheck } from 'gatorcomponents';

const ChangeDomainSuccess = ({
  titleLabel,
  descriptionLabel,
  helpLabel,
  goBackLabel,
  goBack,
  goToLastPageButtonLabel,
  goToLastPage,
  SnappyImage = Snappy,
}) => {
  const handleGoBack = () => {
    goBack && goBack();
  };

  const handleGoToLastPage = () => {
    goToLastPage && goToLastPage();
  };

  return (
    <Styles.ComponentWrapper data-testid="change-domain-success">
      <Styles.HeadWrapper>
        <Styles.IconCircle>
          <IconCircleCheck color="primaryExtraDark" />
        </Styles.IconCircle>
        <Styles.Wrapper>
          <Styles.Title>
            {titleLabel}
          </Styles.Title>
          <Styles.Description>
            {descriptionLabel}
          </Styles.Description>
        </Styles.Wrapper>
      </Styles.HeadWrapper>
      <Styles.ImageWrapper>
        <Styles.Image src={SnappyImage} alt="Imagem Snappy" />
      </Styles.ImageWrapper>
      <Styles.HelpLabel>
        {helpLabel}
      </Styles.HelpLabel>
      <Styles.ButtonsWrapper>
        <Styles.ButtonContainer>
          {goBackLabel && (
            <Button
              label={goBackLabel}
              variant="tertiary"
              width="fit"
              size="medium2"
              iconLeft={<IconArrow direction="left" />}
              onClick={handleGoBack}
              testId="handle-back-button"
            />
          )}
        </Styles.ButtonContainer>
        <Styles.ButtonContainer>
          {goToLastPageButtonLabel && (
            <Button
              label={goToLastPageButtonLabel}
              variant="tertiary"
              width="fit"
              size="medium2"
              iconRight={<IconArrow direction="right" />}
              onClick={handleGoToLastPage}
              testId="go-to-last-page-button"
            />
          )}
        </Styles.ButtonContainer>
      </Styles.ButtonsWrapper>
    </Styles.ComponentWrapper>
  );
};

ChangeDomainSuccess.propTypes = {
  titleLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  descriptionLabel: PropTypes.string,
  helpLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  goBackLabel: PropTypes.string,
  goBack: PropTypes.func,
  goToLastPageButtonLabel: PropTypes.string,
  goToLastPage: PropTypes.func,
};

export default ChangeDomainSuccess;
